<!-- =========================================================================================
  File Name: FormPointCloud.vue
  Description: Form to edit the attributes of a point cloud (ply file)
========================================================================================== -->

<template>
  <div>

    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <label for="" class="vs-input--label">{{ this.$t('HoverpackPlyAutoResize') }}</label>
        <v-select
          :clearable="false"
          v-model="defaultAutoResize"
          label="text"
          class="w-full"
          :options="autosizeOptions"
        />
      </div>
      <div class="vx-col w-2/3"></div>
    </div>
    <form-physical-height
      v-if="defaultAutoResize.value"
      v-multi-ref:form
      v-bind:hobject="hobject"
      v-bind:abilityName="'point_cloud_loader'"
      v-bind:initialModel="initialModel"
    ></form-physical-height>

    <!-- New Point Size input -->
    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <label for="point-size" class="vs-input--label">Point Size</label>
        <vs-input
          id="point-size"
          type="number"
          min="0"
          :step="0.01"
          v-model.number="pointSize"
          class="w-full mb-5"
        />
      </div>
      <div class="vx-col w-2/3"></div>
    </div>

    <span v-bind:key="errorMessageUpload" v-for="errorMessageUpload in errorMessageUploads" class="text-danger"
      >{{ errorMessageUpload }}<br
    /></span>
    <span class="text-danger">{{ errors.first('step-2.name') }}</span>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import FormPhysicalHeight from './FormPhysicalHeight.vue'

export default {
  inject: ['$validator'],
  components: {
    'v-select': vSelect,
    FormPhysicalHeight,
  },
  props: {
    initialPlacement: {},
    hobject: {},
    initialModel: {},
  },
  data() {
    return {
      defaultAutoResize: {
        text: 'Set custom height',
        value: true,
      },
      autosizeOptions: [
        {
          text: 'Set custom height',
          value: true,
        },
        {
          text: 'Keep original model height',
          value: false,
        },
      ],
      errorMessageUploads: [],
      // New attribute for point size with a default value (example: 1)
      pointSize: 1,
    }
  },
  watch: {
    defaultAutoResize: {
      handler: function(updatedValue) {
        console.log('defaultAutoResize')
        console.log(updatedValue.value)

        if (updatedValue.value == false)
          try {
            var abilities = JSON.parse(this.hobject.abilities)
            abilities.point_cloud_loader.height = null
            this.hobject.abilities = JSON.stringify(abilities)
          } catch (e) {
            console.log(e)
            this.height = 100
          }
      },
    },

    hobject: {
      handler: function(updatedValue) {},
    },
    // Update the point_size attribute in hobject's model when pointSize changes
    pointSize(newVal) {
      try {
        let abilities = JSON.parse(this.hobject.abilities)
        abilities.point_cloud_loader.point_size = newVal
        this.hobject.abilities = JSON.stringify(abilities)
      } catch (e) {
        console.log('Error updating point_size:', e)
      }
    },
  },
  mounted() {},

  created() {
  
    var abilities = JSON.parse(this.hobject.abilities)
    if (!abilities.point_cloud_loader.height) {
      console.log('defaultAutoResize false')
      this.defaultAutoResize = {
        text: 'Keep original model height',
        value: false,
      }
    } else {
      console.log('defaultAutoResize true')
      this.defaultAutoResize = {
        text: 'Set custom height',
        value: true,
      }
    }
    // Initialize pointSize from hobject's abilities if available
    try {
      let abilities = JSON.parse(this.hobject.abilities)
      if (abilities.point_size !== undefined && abilities.point_size !== null) {
        this.pointSize = abilities.point_size
      } else {
        this.pointSize = 1  // use default value if not set
      }
    } catch (e) {
      console.log('Error parsing abilities:', e)
      this.pointSize = 1
    }
  },
  methods: {},
  validate() {
    this.errorMessageUploads = []
    return true
  },
}
</script>

<style lang="scss">
.margin-top {
  margin-top: 25px;
}
</style>
